import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, isRef as _isRef, withCtx as _withCtx, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "content-wrapper" }
const _hoisted_2 = { class: "content-wrapper__tabs" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "content-header" }
const _hoisted_5 = { class: "flex scroll-content" }
const _hoisted_6 = { class: "flex" }
const _hoisted_7 = ["onMouseenter"]
const _hoisted_8 = {
  key: 1,
  class: "comment-chip"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = ["onMouseenter"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "replies__asset" }
const _hoisted_13 = { class: "replies__asset" }

import { computed, onMounted, reactive, ref, watch } from 'vue';
import { useTitle, watchDebounced } from '@vueuse/core';
import { useLogsStore } from '@/stores/logs';
import dayjs from 'dayjs'
import TheHeader from '@/components/TheHeader.vue';
import VSocialSelect from '@/components/VSocialSelect.vue';
import VAuthInput from '@/components/VAuthInput.vue';
import VDatePicker from '@/components/VDatePicker.vue';
import Table from '@/components/Table.vue';
import BusinessesSelector from '@/components/BusinessesSelector.vue';
import SearchIcon from '@/components/icons/other/SearchIcon.vue';
import VPagination from '@/components/VPagination.vue';
import { useTabs } from '@/utils/hooks/use-tabs';
import VAssetName from '@/components/VAssetName.vue';
import { useTooltip } from '@/stores/dynamic-tooltip';
import FileSearchIcon from '@/components/icons/other/FileSearchIcon.vue';
import VButton from '@/components/VButton.vue';
import CsvDownloadIcon from '@/components/icons/other/CsvDownloadIcon.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Logs',
  setup(__props) {

const { currentTab, tabs } = useTabs([
  { id: "all", name: "All", path: "" },
  { id: "moderation", name: "Moderation", path: "moderation" },
  { id: "auto_reply", name: "Engagement", path: "auto-reply" },
])

const socialValue = ref<string | null>(null)

const selectedBusiness = reactive<App.Assets>({})

const logsStore = useLogsStore()
onMounted(async () => {
  await logsStore.requestLogs()
})

const currentData = computed(() => {
  return logsStore.logs
})

const columns = {
  date: { title: "Date", width: 250, minWidth: 230, sort: true },
  action: { title: "Action" },
  trigger: { title: "Trigger", minWidth: 50 },
  ad: { title: "Ad/Post", fallback: "-", class: "chips" },
  bms: { title: "BMs", minWidth: 120, class: "min-padding" },
  pages: { title: "Pages", minWidth: 120, class: "min-padding" }
}

watch(() => logsStore.queryParams, async () => {
  await logsStore.requestLogs()
})

watch(currentTab, async (tab) => {
  if (tab === "all") {
    logsStore.params.category_id = undefined
  }
  if (tab === "moderation") {
    logsStore.params.category_id = 1
  }
  if (tab === "auto_reply") {
    logsStore.params.category_id = 2
  }
}, { immediate: true })

watchDebounced(selectedBusiness, async (selected) => {
  const _values = { 
    filter_business_ids: selected.businesses || [], 
    filter_page_ids: selected.pages || [], 
    filter_ad_account_ids: selected.ad_accounts || [] 
  }
    
  for (let [_key, value] of Object.entries(_values)) {
    const key = _key as "filter_business_ids" | "filter_page_ids" | "filter_ad_account_ids"
    if (value.length > 0) {
      logsStore.params[key] = value as string[]
    } else {
      logsStore.params[key] = undefined
    }
  }
}, { debounce: 400 })

const searchValue = ref("")

watch(socialValue, (value) => {
  if (value === null) {
    delete logsStore.params.connect_ids
  }
  if (value === "fb") {
    logsStore.params.connect_ids = [ 1 ]
  }
  if (value === "ig") {
    logsStore.params.connect_ids = [ 2 ]
  }
  if (value === "tiktok") {
    logsStore.params.connect_ids = [ 3 ]
  }
})
watchDebounced(searchValue, (value) => {
  logsStore.params.search = value
}, { debounce: 400 })

useTitle("Logs | Reply200")

const tooltip = useTooltip()


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(TheHeader, { title: "Activity Logs" }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabs), (tab) => {
          return (_openBlock(), _createElementBlock("button", {
            class: _normalizeClass({ active: _unref(currentTab) === tab.id }),
            onClick: ($event: any) => (currentTab.value = tab.id)
          }, _toDisplayString(tab.name), 11, _hoisted_3))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(VSocialSelect, {
            modelValue: socialValue.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((socialValue).value = $event)),
            class: "mr-2"
          }, null, 8, ["modelValue"]),
          _createVNode(BusinessesSelector, {
            modelValue: selectedBusiness,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(selectedBusiness) ? (selectedBusiness).value = $event : null)),
            small: "",
            showInstagrams: true
          }, null, 8, ["modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(VButton, {
            class: "mr-2",
            onClick: _unref(logsStore).exportCsv
          }, {
            default: _withCtx(() => [
              _createVNode(CsvDownloadIcon)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(VAuthInput, {
            modelValue: searchValue.value,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((searchValue).value = $event)),
            icon: SearchIcon,
            placeholder: "Search",
            class: "light search",
            clearable: ""
          }, null, 8, ["modelValue"]),
          _createVNode(VDatePicker)
        ])
      ]),
      _createVNode(Table, {
        columns: columns,
        data: _unref(currentData),
        "row-key": "id",
        "default-sort": "date",
        loading: !_unref(logsStore).loaded,
        sort: _unref(logsStore).params.sort,
        "onUpdate:sort": _cache[3] || (_cache[3] = ($event: any) => ((_unref(logsStore).params.sort) = $event))
      }, {
        date: _withCtx(({ cell }) => [
          _createTextVNode(_toDisplayString(_unref(dayjs)(cell).format("MM/DD/YY, hh:mm:ss A").toUpperCase()), 1)
        ]),
        action: _withCtx(({ cell, item }) => [
          (item.comment_reply_message)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "reply-chip",
                onMouseenter: ($event: any) => (_unref(tooltip).showTooltip($event, item.comment_reply_message, 'top'))
              }, _toDisplayString(cell.name), 41, _hoisted_7))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(cell.name), 1))
        ]),
        ad: _withCtx(({ cell }) => [
          _createElementVNode("a", {
            class: "reply-chip",
            href: cell.url,
            target: "_blank"
          }, _toDisplayString(cell.id), 9, _hoisted_9)
        ]),
        trigger: _withCtx(({ cell, item }) => [
          (cell.name)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "reply-chip",
                onMouseenter: ($event: any) => (_unref(tooltip).showTooltip($event, item.comment_message, 'top'))
              }, _toDisplayString(cell.name), 41, _hoisted_10))
            : (cell.keys)
              ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cell.keys, (key) => {
                    return (_openBlock(), _createElementBlock("div", null, _toDisplayString(key), 1))
                  }), 256))
                ]))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode("-")
                ], 64))
        ]),
        bms: _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(VAssetName, {
              item: item.business
            }, null, 8, ["item"])
          ])
        ]),
        pages: _withCtx(({ item }) => [
          _createElementVNode("div", _hoisted_13, [
            _createVNode(VAssetName, {
              item: item.page
            }, null, 8, ["item"])
          ])
        ]),
        _: 1
      }, 8, ["data", "loading", "sort"]),
      _createVNode(VPagination, {
        meta: _unref(logsStore).meta,
        onChangepage: _unref(logsStore).setPage
      }, null, 8, ["meta", "onChangepage"])
    ])
  ], 64))
}
}

})